import React, { useEffect, useState, useCallback } from 'react';
import Navigation from '../components/Navigation';
import { NavLink } from 'react-router-dom';
import base_url from '../config/Config';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
// import Spinner from 'react-bootstrap/Spinner';
import { FaEyeSlash } from 'react-icons/fa';
import Cookies from 'js-cookie';
import PageLoader from '../components/PageLoader';

const LoanList = () => {
    const [loanMaster, setLoanMaster] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const queryParams = new URLSearchParams(window.location.search);
    const customerId = queryParams.get('customerId');
    const token = Cookies.get('authToken');

    const getAllLoanMaster = useCallback(() => {
        axios.get(`${base_url}/api/loan/viewByCustomerId?customerId=${customerId}`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        })
        .then((response) => {
            const sortedLoans = response.data.sort((a, b) => b.id - a.id); // sort by ID DESC
            setLoanMaster(sortedLoans);
        })
            .catch((error) => {
                console.error("Error fetching loan master list:", error);
            })
            .finally(() => setPageLoading(false));
    }, [token, customerId]);

    useEffect(() => {
        if (token) {
            getAllLoanMaster();
        }
    }, [token, getAllLoanMaster]);


    return (
        <>
            <div className='overviewsaa'>
                <h4>Customer Details</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms mt-5 text-center'>
                            <div className='row'>
                                <div className="col-md-12 col-lg-12">
                                    <div className="reportsanalyzier mb-3">
                                        <div className="row">
                                            <div className="col-lg-2 col-md-2">
                                                <div className="credit buttonandly">
                                                    <NavLink to={`/headerfile/CreditReport?id=${customerId}`}><p>Credit Report</p></NavLink>
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2">
                                                <div className="analyzier buttonandly">
                                                     <NavLink to={`/headerfile/LoanAgreement?id=${customerId}`}><p>Loan Agreement</p></NavLink>
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2">
                                                <div className="digitalfoot buttonandly">
                                                     <p>Loan Product</p>
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2">
                                                <div className="devicehistory buttonandly">
                                                    <NavLink to={`/operation/ViewVerifiedCustomer?id=${customerId}`}><p>Customer View</p></NavLink>
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2">
                                                <div className="location buttonandly">
                                                    <NavLink to={`/document/LoanDocuments?customerId=${customerId}`}> <p>Document</p></NavLink>
                                                </div>
                                            </div>
                                            <div className="col-lg-2 col-md-2">
                                                <div className="businessverification buttonandly">
                                                    <NavLink to={`/headerfile/NOC?id=${customerId}`}><p>NOC</p></NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <hr /> */}
                                {/* <div className='col-md-12'>
                                    <div className='searchtoll'>
                                        <form onSubmit={handleSearch}>
                                            <div className='row'>
                                                <div className="col-md-3 col-3">
                                                    <div className=" required">
                                                        <select name="option" id="option" className="form-control" value={searchOption} onChange={(e) => setSearchOption(e.target.value)} required>
                                                            <option value="">Search By</option>
                                                            <option value="borrower_name">Borrower Name</option>
                                                            <option value="borrower_id">Loan Id</option>
                                                            <option value="phone">Phone</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-5 col-6">
                                                    <div className=" required">
                                                        <input type="text" className="form-control" placeholder="Search..." value={searchInput} onChange={(e) => setSearchInput(e.target.value)} required />
                                                    </div>
                                                </div>
                                                <div className="col-md-2 col-3">
                                                    <div className=" required iconsss">
                                                        <button type="submit" className="btn btn-sm btn-primary">Search</button>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className='resion'>
                                                        <NavLink to="#" className="exportbutton" onClick={handleExportLoanMaster}>
                                                            {isDownloading ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <>Export <FaDownload /></>
                                                            )}
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div> */}
                                <div className='col-md-12 col-lg-12'>
                                    <div className='allcustomer table-responsive mt-3'>
                                        { pageLoading ? <PageLoader text="Loading..." /> : loanMaster.length > 0  ? (
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Product_Id</th>
                                                        <th>Customer_Id</th>
                                                        <th>Loan_Amount</th>
                                                        <th>Interest</th>
                                                        <th>Interest_Type</th>
                                                        <th>Processing_Fee</th>
                                                        <th>Other_Deduction</th>
                                                        <th>Tenure_(Days)</th>
                                                        <th>Repayment_Type</th>
                                                        <th>Number_of_EMI</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {loanMaster.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>US0{data.id}</td>
                                                            <td>{data.customerId}</td>
                                                            <td>{data.loanAmount}</td>
                                                            <td>{data.interestRate}</td>
                                                            <td>{data.interestRateType}</td>
                                                            <td>{data.processFee}</td>
                                                            <td>{data.otherDeduction}</td>
                                                            <td>{data.tenureInDays}</td>
                                                            <td>{data.repaymentType}</td>
                                                            <td>{data.numberOfEmi}</td>
                                                            <td className='iconss'>
                                                                <NavLink to={`/loanmaster/ViewLoan?customerId=${data.customerId}&loanId=${data.id}`}>
                                                                    <FaEyeSlash />
                                                                </NavLink>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            "No Loan Product"
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LoanList;
